// @ngInject
function ArticleTypesApiService($q, $rootScope, DS, DSHttpAdapter) {

    return {
        getAll: getAll,
        getArticleType: getArticleType,
        save: save
    };

    function getAll(filter) {
        var deferred = $q.defer();

        var params = {};
        if (!_.isEmpty(filter)) {
            params.filter = filter;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'products/articletypes', { params: params }).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function getArticleType(id) {
        var deferred = $q.defer();
        DSHttpAdapter.GET(DS.defaults.basePath + 'products/articletypes/' + id)
            .then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    function save(articleType) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'products/articletypes/save/' + articleType.id, articleType).then(function (response) {
            deferred.resolve(response);
            $rootScope.$emit('ArticleType.Updated', response.data);
            $rootScope.$emit('ArticleType.Changed', response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }
}


angular.module('articletypes.api', [])
  .factory('ArticleTypesApiService', ArticleTypesApiService);
